import EFOcats_logic from '../efocats_logic.js';

/**
 * エラーチェッククラス
 */
export default class efocats_validate_core extends EFOcats_logic {
  /**
   * エラーチェック
   */
  validate(checkData) {
    // 子クラスで実装する
  }

  /**
   * 誕生日置換
   * @param {*} elem
   */
  rep_birthday(elem) {
    let material_val = elem.val();
    // 大文字の数字を小文字の数字に置換
    material_val = material_val.replace(/[０-９]/g, s => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });

    const digitVal = material_val.split('/');

    if (digitVal[1] < 10 && digitVal[2] < 10 && digitVal[1].split('')[0] !== 0 && digitVal[2].split('')[0] !== 0) {
      material_val = `${digitVal[0]}/0${digitVal[1]}/0${digitVal[2]}`;
    } else if (digitVal[1] < 10 && digitVal[1].split('')[0] !== 0) {
      material_val = `${digitVal[0]}/0${digitVal[1]}/${digitVal[2]}`;
    } else if (digitVal[2] < 10 && digitVal[2].split('')[0] !== 0) {
      material_val = `${digitVal[0]}/${digitVal[1]}/0${digitVal[2]}`;
    }

    material_val = material_val.replace(/[^0-9]/g, '');
    material_val = this.strIns(material_val, 4, '/');
    material_val = this.strIns(material_val, 7, '/');
    elem.val(material_val);
  }

  /**
   * 文字の挿入
   */
  strIns(str, idx, val) {
    const res = str.slice(0, idx) + val + str.slice(idx);
    return res;
  }
}
